var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 4.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.7 4.1c-.1 0-.2 0-.3-.1L-.1.4C-.3.3-.4 0-.2-.2s.4-.2.6-.1l4.3 3.4L9-.3c.2-.2.5-.1.6.1s.1.5-.1.6L5 4c-.1.1-.2.1-.3.1"
  })));
};
export default SvgChevronDown;